<template>
  <TemplateDetailLayout class="settings-tab">
    <template #option-heading>
      <AppHeading text="Información" tag="h3" />
    </template>
    <template #option-content>
      <AppList class="settings-tab__listing" :items="settingsList">
        <template #item-content="{ currentItem }">
          <!-- STATUS -->
          <template v-if="currentItem.key === 'status'">
            <div class="settings-tab__setting status">
              <span class="settings-tab__setting-text">
                <AppIcon icon="fas fa-signal-stream" />
                {{ currentItem.text }}
              </span>
              <!-- status -->
              <TemplatesTemplateStatus :status="template[currentItem.key]">
                {{ template[currentItem.key] }}
              </TemplatesTemplateStatus>
            </div>
          </template>

          <!-- LANGUAGE -->
          <template v-else-if="currentItem.key === 'language'">
            <div class="settings-tab__setting" :class="currentItem.key">
              <span class="settings-tab__setting-text">
                <AppIcon icon="fas fa-globe" />
                {{ currentItem.text }}
              </span>
              <!-- value -->
              <span class="settings-tab__setting-label">
                {{ languageLabel(template[currentItem.key]) }}
              </span>
            </div>
          </template>

          <!-- CATEGORY -->
          <template v-else-if="currentItem.key === 'category'">
            <div class="settings-tab__setting" :class="currentItem.key">
              <span class="settings-tab__setting-text">
                <AppIcon icon="fas fa-tags" />
                {{ currentItem.text }}
              </span>
              <CardCategory :category="template[currentItem.key]" />
            </div>
          </template>
          <!-- EDITORS -->
          <template v-else-if="currentItem.key === 'editors'">
            <div class="settings-tab__setting" :class="currentItem.key">
              <span class="settings-tab__setting-text">
                <AppIcon icon="fas fa-user-friends" />
                {{ currentItem.text }}
              </span>
              <CardUsers :users="template[currentItem.key]" />
            </div>
          </template>
          <!-- TYPE -->
          <div
            v-else-if="currentItem.key === 'type'"
            class="settings-tab__setting"
            :class="currentItem.key"
          >
            <span class="settings-tab__setting-text">
              <AppIcon icon="fas fa-file-search" />
              Tipo
            </span>
            <span class="settings-tab__setting-badges">
              <ActionTypeBadge
                v-for="value in currentItem.values"
                :key="value"
                :card="template"
                :type="value"
              />
            </span>
          </div>
          <!-- HubSpot Slug -->
          <div
            v-else-if="currentItem.key === 'hs_slug'"
            class="settings-tab__setting"
            :class="currentItem.key"
          >
            <span class="settings-tab__setting-text">
              <AppIcon :icon="templateTypeIcon(currentItem.key)" />
              {{ currentItem.text }}
            </span>
            <span class="settings-tab__setting-slug">
              <a :href="actionUrl(template[currentItem.key])" target="_blank">
                Ver
                <AppIcon icon="far fa-external-link-alt" />
              </a>
            </span>
          </div>
          <!-- REST OF INFO -->
          <div
            v-else-if="template[currentItem.key]"
            class="settings-tab__setting"
            :class="currentItem.key"
          >
            <span class="settings-tab__setting-text">
              <AppIcon :icon="templateTypeIcon(currentItem.key)" />
              {{ currentItem.text }}
            </span>
            <span class="settings-tab__setting-value">
              {{ template[currentItem.key] }}
            </span>
          </div>
        </template>
      </AppList>
      <TemplatesArchiveButton />
    </template>
  </TemplateDetailLayout>
</template>

<script>
// Utilities
import { actionURLBase } from 'Utils/config/diy'
// Components
import AppIcon from 'Ui/AppIcon'
import AppList from 'Ui/AppList'
import AppHeading from 'Ui/AppHeading'
import CardUsers from 'Components/CardUsers'
import CardCategory from 'Components/CardCategory'
import ActionTypeBadge from 'Components/ActionTypeBadge'
import TemplateDetailLayout from 'Layouts/TemplateDetailLayout'
import TemplatesArchiveButton from 'Modules/Templates/components/TemplatesArchiveButton'
import TemplatesTemplateStatus from 'Modules/Templates/components/TemplatesTemplateStatus'

export default {
  name: 'TemplateDetailsPageSettingsTab',

  components: {
    AppIcon,
    AppList,
    CardUsers,
    AppHeading,
    CardCategory,
    ActionTypeBadge,
    TemplateDetailLayout,
    TemplatesArchiveButton,
    TemplatesTemplateStatus,
  },
  props: {
    template: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      settingsList: [
        { text: 'Status', key: 'status' },
        { text: 'Idioma', key: 'language' },
        { text: 'Categoría', key: 'category' },
        { text: 'Editores', key: 'editors' },
        { text: 'Tipo', key: 'type', values: ['recurrent', 'technical'] },
        { text: 'Slots', key: 'slots' },
        { text: 'HubSpot URL', key: 'hs_slug' },
      ],
    }
  },
  computed: {
    isPublished() {
      return this.template.status === 'published'
    },

    languageLabel() {
      return (code) => {
        return code === 'es' ? 'Castellano' : 'Inglés'
      }
    },

    actionUrl() {
      return (slug) => actionURLBase + slug
    },

    templateTypeIcon() {
      return (type) => {
        switch (type) {
          case 'slots':
            return 'fas fa-chart-pie'
          case 'hs_slug':
            return 'fab fa-hubspot'
        }
      }
    },
  },
}
</script>

<style scoped>
.settings-tab__listing {
  display: inline-block;
  width: 100%;
  /* max-width: 450px; */
  min-width: 200px;
}

.settings-tab >>> .settings-tab__listing .app-list__item:not(:first-of-type) {
  margin-top: 20px;
}

.settings-tab__setting {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, auto));
  column-gap: 0;
  align-items: center;
  justify-items: flex-end;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--c-secondary-400);
}

.settings-tab__setting.status >>> .template-status {
  grid-template-columns: 15px auto;
  justify-items: flex-end;
}

.settings-tab__setting.status >>> .template-status .template-status__text {
  text-transform: capitalize;
}

.settings-tab__setting.editors .card-users {
  margin-left: 10px;
}

.settings-tab__setting.category .card-category {
  font-size: 12px;
  padding: 5px 10px;
}

.settings-tab__setting.hs_slug a {
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  color: var(--c-primary);
  letter-spacing: 0.5px;
  text-decoration: none;
}

.settings-tab__setting.hs_slug a:hover {
  text-decoration: underline;
}

.settings-tab__setting-text {
  display: grid;
  grid-template-columns: 30px auto;
  align-items: center;
  justify-content: space-between;
  justify-self: flex-start;
  letter-spacing: 0.3px;
  font-weight: 700;
  white-space: nowrap;
}

.settings-tab__setting-value {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: var(--c-secondary);
  width: 40px;
  height: 40px;
  border: 2px solid var(--c-secondary);
  border-radius: 50px;
}

.settings-tab__setting-badges {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
}

.settings-tab__setting-badges >>> .badge {
  padding: 7px 12px;
}

.settings-tab__setting-badges >>> .badge span {
  font-size: 14px;
  color: #fff;
}

.app-icon {
  color: var(--c-secondary);
  margin-right: 8px;
}

.template-detail-layout__content .submit-button {
  margin: 40px 0 0 auto;
}

/* Responsive ----- */
@media (max-width: 480px) {
  .settings-tab__setting {
    row-gap: 20px;
  }
}

@media (max-width: 380px) {
  .settings-tab__setting {
    grid-template-columns: 1fr;
    justify-items: flex-start;
  }

  .settings-tab__setting > :last-child,
  .settings-tab__setting.editors .card-users {
    margin-left: 30px;
  }
}
</style>
